<template>
  <div>
    <p class="text-xs-center">{{title}}</p>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
  import {Bar, mixins} from 'vue-chartjs'
  // import ChartDataLabels from 'chartjs-plugin-datalabels';

  export default {
    extends: Bar,
    mixins: [mixins.reactiveData],
    //plugins: [ChartDataLabels],
    props: {
      title: {
        type: String,
        default: ""
      },
      legendPosition: {
        type: String,
        default: "bottom"
      },
      aspectRatio:{
        type: Number,
        default: 3
      },
      data: {
        type: Array,
        default: []
      },
      sorted: {
        type: Boolean,
        default: true
      },
      series: {
        type: Array,
        // 所有可能的数据
        default: () => [
          {value: 'totalAmount', label: '总规模', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
          {value: 'newAmount', label: '新立合同规模', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
          {value: 'inResearchAmount', label: '在研合同规模', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
          {value: 'income', label: '项目到款', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
          {value: 'totalCount', label: '项目总数', yAxisID: 'y-axis-1'},
          {value: 'newCount', label: '新立项目数', yAxisID: 'y-axis-1'},
          {value: 'inResearchCount', label: '在研项目数', yAxisID: 'y-axis-1'},
        ]
      }
    },

    data() {
      return {
        chartData: null,
        options: {
          aspectRatio: this.aspectRatio || 3,
          legend: {
            position: this.legendPosition || 'bottom'
          },
          responsive: true,
          title: {
            display: false,
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            yAxes: [{
              type: 'linear',
              display: true,
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '数量'
              },
              id: 'y-axis-1',
            }, {
              type: 'linear',
              display: true,
              position: 'right',
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '金额（万元）'
              },
              id: 'y-axis-2',

              // grid line settings
              gridLines: {
                drawOnChartArea: false,
              },
            }]
          },
        }
      }
    },
    created() {
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
    watch: {
      data(nv, ov) {
        const orderMap = {"国家级": 1, "省部级": 2, "地厅级": 3, "市局级": 4, "校级": 5, "企业委托课题": 6};
        // const colors = ['#ff7f0e', '#1f77b4', '#2ca02c', '#3366cc', '#bcbd22', '#d62728',
        //   '#17becf', '#9467bd', '#7f7f7f', '#8c564b', '#e377c2'];
        const colors = [
          "#c23531",
          "#2f4554",
          "#61a0a8",
          "#d48265",
          "#91c7ae",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3"
        ];
        const sortedData = this.sorted ? nv : nv.map(e => {
          e.order = orderMap[e.label] || 99;
          e.label = e.label || "其它";
          return e
        }).sort((a, b) => a.order - b.order);

        this.chartData = {
          labels: sortedData.map(e => e.label),
          datasets: this.series.map((s, i) => {
            return {
              label: s.label,
              data: sortedData.map(e => e[s.value]),
              backgroundColor: colors[i],
              fill: s.fill,
              type: s.type,
              yAxisID: s.yAxisID
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
